import { axiosRequest } from '@/plugins/axios-common'

import { handleError } from '@/store/handle-error'

export const UserGroupActions = {

  getUserGroups: async ({ commit }) => {
    return axiosRequest.get('/user_groups').
      then(({ data }) => {
        commit('setUserGroups', data)
      }).
      catch(handleError)
  },

}
